import type { Dispatch, SetStateAction } from 'react';
import type { TransferContextData } from '../ovComponents/4-module/workflowCompletion/workflowTypes';

export const updateContextTransfer = async ({
  value,
  setApplicationContext,
  setWorkflowCompletionContext,
}: {
  existingContext: any;
  value: any;
  setApplicationContext?: Dispatch<SetStateAction<TransferContextData>>;
  setWorkflowCompletionContext?: Dispatch<SetStateAction<TransferContextData>>;
}) => {
  if (setApplicationContext) {
    await setApplicationContext((previous: TransferContextData) => ({
      ...previous,
      ...value,
    }));
  } else {
    await setWorkflowCompletionContext?.((previous: TransferContextData) => ({
      ...previous,
      ...value,
    }));
  }
};
